import { Stack, TextInput } from '@mantine/core';
import { i18nKeys, useTranslation } from 'locales';
import { useAmlFormContext } from '../types/types';

export function CompanyStep() {
  const { t } = useTranslation();
  const form = useAmlFormContext();

  return (
    <Stack gap="md" mt="md">
      <TextInput
        required
        label={t(i18nKeys.AML_MODAL.COMPANY_IDENTIFICATION.CASE_NAME)}
        placeholder={t(i18nKeys.AML_MODAL.COMPANY_IDENTIFICATION.PLACEHOLDERS.CASE_NAME)}
        {...form.getInputProps('caseName')}
      />
      <TextInput
        required
        label={t(i18nKeys.AML_MODAL.COMPANY_IDENTIFICATION.COMPANY_NAME)}
        placeholder={t(i18nKeys.AML_MODAL.COMPANY_IDENTIFICATION.PLACEHOLDERS.COMPANY_NAME)}
        {...form.getInputProps('companyName')}
      />
      <TextInput
        required
        label={t(i18nKeys.AML_MODAL.COMPANY_IDENTIFICATION.VAT_NUMBER)}
        placeholder={t(i18nKeys.AML_MODAL.COMPANY_IDENTIFICATION.PLACEHOLDERS.VAT_NUMBER)}
        {...form.getInputProps('vatNumber')}
      />
      <TextInput
        required
        label={t(i18nKeys.AML_MODAL.COMPANY_IDENTIFICATION.REGISTERED_OFFICE)}
        placeholder={t(i18nKeys.AML_MODAL.COMPANY_IDENTIFICATION.PLACEHOLDERS.REGISTERED_OFFICE)}
        {...form.getInputProps('registeredOffice')}
      />
    </Stack>
  );
}
